import { useEffect, useRef, useState } from 'react';

const DefaultHeightFromTop = 144;
const RecalculateEvery = 1000;

// For some reason chrome doesn't include scrollbars into height calculation. Possible suspect https://stackoverflow.com/questions/12989931/body-height-100-displaying-vertical-scrollbar/22166728#22166728
// Affected Thread https://rocketlane.slack.com/archives/C012NM7KM8U/p1663863180675669
// until its fixed. this is a hot fix
export const useSwimlaneHeight = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(DefaultHeightFromTop);
  const swimlane = ref.current;

  const swimlaneHeight = swimlane?.getBoundingClientRect().top;

  useEffect(() => {
    if (!swimlaneHeight) {
      return undefined;
    }
    const timeout = setTimeout(() => {
      setHeight(swimlaneHeight);
    }, RecalculateEvery);

    return () => clearTimeout(timeout);
  }, [swimlaneHeight]);

  return { ref, height };
};
